import type { ProductType } from "@solarwinds-webbiz/types";

export type EnrichedProductReference = {
  value?: {
    data?: {
      mainInformation?: {
        longName?: string;
        shortName?: string;
        programId?: string;
        categories?: string[];
      };
      analytics?: {
        registrationEvent?: string;
      };
      onlineQuote?: {
        value?: {
          data?: {
            catalogId?: string;
          };
        };
      };
    };
  };
};

export function mapBuilderProduct(
  ref: EnrichedProductReference | undefined,
): [ProductType] | [] {
  const data = ref?.value?.data;
  if (!data) {
    return [];
  }

  const catalogId = data.onlineQuote?.value?.data?.catalogId;

  return [
    {
      main_information: {
        long_name: data.mainInformation?.longName ?? "",
        short_name: data.mainInformation?.shortName,
        program_id: data.mainInformation?.programId,
        global_field: {
          categories: data.mainInformation?.categories,
        },
      },
      product: catalogId
        ? [
            {
              online_quote_information: {
                online_quote_catalog_id: catalogId,
              },
            },
          ]
        : [],
      analytics: {
        registration_event: data.analytics?.registrationEvent,
      },
    } as ProductType,
  ];
}
